import { Controller } from "@hotwired/stimulus"

// L'interrupteur « Détails techniques » du catalogue (fiche produit, fiche d'un fork, page Migrations) : posé par
// Insurance::Catalog::TechnicalSwitchComponent sur un bouton role="switch".
//
// Il affiche ou cache la couche technique sans recharger la page. Tout ce qui parle du code est soit un
// `details.insurance-catalog-tech` (« Voir dans le code »), soit un élément `[data-catalog-tech]` ; le CSS les cache sous
// un ancêtre `[data-catalog-technical="off"]` (cf. _insurance_catalog.scss). Au clic, on bascule cet attribut sur
// l'ancêtre le plus proche de l'interrupteur qui le porte (la coquille de la fiche, qui englobe en-tête, sommaire,
// diapositives et panneau), à défaut sur tous ceux du document, et l'on pose (ou retire) le cookie
// insurance_catalog_technical=1, par navigateur, un an, que le serveur lit pour la page suivante. Les pages voisines
// qui arrivent ensuite sont sous le même ancêtre : rien à faire pour elles. On n'ouvre rien : allumé, tout apparaît
// replié, dépliable un à un.
//
// Valeur : `on`, l'état lu par le serveur, puis tenu à jour.
const COOKIE = "insurance_catalog_technical"
const ONE_YEAR = 60 * 60 * 24 * 365
const SCOPE = "[data-catalog-technical]"

export default class extends Controller {
  static values = { on: Boolean }

  toggle() {
    const on = !this.onValue
    const attributes = ["path=/", `max-age=${on ? ONE_YEAR : 0}`, "SameSite=Lax"]
    if (window.location.protocol === "https:") attributes.push("Secure")
    document.cookie = [`${COOKIE}=${on ? "1" : ""}`, ...attributes].join("; ")

    this.onValue = on
  }

  // À la connexion (valeur du serveur) et à chaque bascule : l'interrupteur et ce qu'il gouverne disent la même chose.
  onValueChanged() {
    this.element.setAttribute("aria-checked", String(this.onValue))
    const state = this.onValue ? "on" : "off"
    for (const scope of this.scopes) {
      if (scope.dataset.catalogTechnical !== state) scope.dataset.catalogTechnical = state
    }
  }

  get scopes() {
    const closest = this.element.closest(SCOPE)
    return closest ? [closest] : [...document.querySelectorAll(SCOPE)]
  }
}
